import script from "./VideoCallConfig.vue.ts?vue&type=script&setup=true&lang=ts!=!../../../../node_modules/rspack-vue-loader/dist/index.js??ruleSet[0].use[0]!./VideoCallConfig.vue?vue&type=script&setup=true&lang=ts"
export * from "./VideoCallConfig.vue.ts?vue&type=script&setup=true&lang=ts!=!../../../../node_modules/rspack-vue-loader/dist/index.js??ruleSet[0].use[0]!./VideoCallConfig.vue?vue&type=script&setup=true&lang=ts"

import "./VideoCallConfig.vue.scss?vue&type=style&index=0&id=b4d70a77&lang=scss!=!../../../../node_modules/rspack-vue-loader/dist/index.js??ruleSet[0].use[0]!./VideoCallConfig.vue?vue&type=style&index=0&id=b4d70a77&lang=scss"

const __exports__ = script;

export default __exports__